import type { ReactNode } from 'react'
import { Box, Flex, Text } from '@radix-ui/themes'

interface TabHeaderProps {
  children: ReactNode
  action?: ReactNode
}

export const TabHeader = ({ children, action }: TabHeaderProps) => (
  <Flex align="center" justify="between" gap="4">
    <Text size="2" color="gray">
      {children}
    </Text>
    {action ? <Box className="shrink-0">{action}</Box> : null}
  </Flex>
)
